import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
/* This code is needed to properly load the images in the Leaflet CSS */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


$(document).ready(() => {
    $('.header__burger').on('click', () => {
        $('.header__burger, .header__menu').toggleClass('active');
    });

    $('.header__contact .search').on('click', () => {
        $('.header__search-form').toggleClass('active');
    });

    $('.services__list li:not(.link)').on('click', function () {
        const $this = $(this);

        $('.services__list li:not(.link)').removeClass('active');
        $this.addClass('active');
        $('.services__single').removeClass('active').filter(`[data-id="${$this.attr('data-id')}"]`).addClass('active');
    });

    if ($('.doctors-slider').length) {
        const swiper = new Swiper('.doctors-slider .swiper', {
            modules: [Navigation, Pagination],
            pagination: {
                el: '.doctors-slider .swiper-pagination',
                clickable: true,
            },
            spaceBetween: 20,
            slidesPerView: 1,
            breakpoints: {
                550: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
            },
        });
    }

    if ($('.posts-slider').length) {
        const swiper = new Swiper('.posts-slider .swiper', {
            modules: [Navigation, Pagination],
            pagination: {
                el: '.posts-slider .swiper-pagination',
                clickable: true,
            },
        });
    }

    if ($('.opinions-banner').length) {
        const swiper = new Swiper('.opinions-banner .swiper', {
            modules: [Navigation, Pagination],
            pagination: {
                el: '.opinions-banner .swiper-pagination',
                clickable: true,
            },
        });
    }

    (() => {
        let zoom = 1;
        jQuery('body').openAccessibility({
            localization: ['en']
        });
        $('.open-accessibility [data-lang="zoom-in"]').text('Przybliż');
        $('.open-accessibility [data-lang="zoom-out"]').text('Oddal');
        $('.open-accessibility [data-lang="bigger-cursor"]').text('Większy kursor');
        $('.open-accessibility [data-lang="invert"]').text('Odwróć kolory');
        $('.open-accessibility [data-lang="contrast"]').text('Kontrast');
        $('.open-accessibility [data-lang="brightness"]').text('Jasność');
        $('.open-accessibility [data-lang="reset"]').text('Cofnij zmiany');
        $('.open-accessibility [data-lang="grayscale"]').text('Skala szarości');
        $('.open-accessibility-zoom-in-button').on('click', () => {
            zoom += .05;
            zoom = Math.min(zoom, 1.3);
            $('html').css('zoom', zoom);
        });
        $('.open-accessibility-zoom-out-button').on('click', () => {
            zoom -= .05;
            zoom = Math.max(zoom, 0.7);
            $('html').css('zoom', zoom);
        });
        $('.open-accessibility-reset-button').on('click', () => {
            zoom = 1;
            $('html').css('zoom', zoom);
        });
    })();

    if ($('.map').length) {
        const $map = $('.map__container');
        const map = L.map($map[0], {
            scrollWheelZoom: false,
        });
        const basemap = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Beskidzki Zespół Leczniczo-Rehabilitacyjny Szpital Opieki Długoterminowej w Jaworzu'
        });

        let pins = JSON.parse($map.attr('data-pins'));
        if (pins) {
            let bounds = [];
            pins.forEach(pin => {
                const ll = [+pin.lat, +pin.lng];
                const marker = L.marker(ll).bindPopup(`
                    <h4 style="margin:0">${pin.title}</h4>
                    <p style="margin:0">${pin.content}</p>
                `);
                marker.addTo(map);
                bounds.push(ll);
            });
            map.fitBounds(bounds);
            map.setZoom(map.getZoom() - 1);
        }

        basemap.addTo(map);
    }

    if ($('.hero').length) {
        let slide = 1;
        let slideInterval = 10000;
        let max = $('.hero__background img').length;
        let swapSlide = (xslide = false) => {
            slide++;
            if (slide > max) slide = 1;
            if (xslide) slide = xslide;

            $('.hero-slide').hide();
            $('.hero-slide-' + slide).show();
            $('.hero__dots button').removeClass('active');
            $('.hero__dots button[data-slide="' + slide + '"]').addClass('active');
        };
        let interval = setInterval(() => {
            swapSlide();
        }, slideInterval);
        $('.hero__dots button').on('click', function () {
            clearInterval(interval);
            swapSlide($(this).attr('data-slide'));
            interval = setInterval(() => {
                swapSlide();
            }, slideInterval);
        })
    }
});